import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { Alert } from '../../../../components/Alert';
import { PageSpinner } from '../../../../components/PageSpinner';
import { billingApi } from '../../../../features/billing/billing.api';
import { PaymentReceiptDisplay } from '../../../../features/billing/PaymentReceiptDisplay';
import { toDisplayMessage } from '../../../../lib/error-message';
import { paths, routeTo } from '../../../../routes/paths';
import styles from '../AdminPortal.module.css';

export function AdminPaymentReceiptPage(): React.JSX.Element {
  const { id = '' } = useParams<{ id: string }>();

  const receipt = useQuery({
    queryKey: ['admin', 'payments', id, 'receipt'],
    queryFn: () => billingApi.getAdminPaymentReceipt(id),
    enabled: id !== '',
  });

  if (receipt.isPending) {
    return <PageSpinner label="Loading receipt" />;
  }

  if (receipt.isError) {
    return <Alert tone="error">{toDisplayMessage(receipt.error)}</Alert>;
  }

  return (
    <div className={styles.page}>
      <p>
        <Link to={paths.adminPayments}>Back to posted payments</Link>
        {' · '}
        <Link to={routeTo.adminPayment(id)}>Payment details</Link>
      </p>

      <PaymentReceiptDisplay data={receipt.data} />
    </div>
  );
}
